"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowButton = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var CornerDown_1 = require("../icons/CornerDown");
var useArrowStyles = (0, system_1.makeStyles)(function (theme) { return ({
    root: __assign(__assign({ width: 24, height: '24px !important', minWidth: '24px !important', padding: 0, outline: 'none', border: 'none', backgroundColor: 'transparent', cursor: 'pointer', borderRadius: 4 }, theme.go.mixins.effects.Hovered()), theme.go.mixins.effects.Pressed()),
    arrow: {
        color: theme.go.schemes.colors.system.IconMain,
    },
    arrowRight: {
        transform: 'rotate(-90deg)',
    },
    arrowLeft: {
        transform: 'rotate(90deg)',
    },
}); });
exports.ArrowButton = (0, react_1.memo)(function ArrowButton(_a) {
    var direction = _a.direction, className = _a.className, props = __rest(_a, ["direction", "className"]);
    var _b = useArrowStyles(), arrowRight = _b.arrowRight, arrowLeft = _b.arrowLeft, arrow = _b.arrow, root = _b.root;
    return (react_1.default.createElement("button", __assign({}, props, { type: "button", className: (0, utils_1.cn)(className, root) }),
        react_1.default.createElement(CornerDown_1.CornerDownIcon, { className: (0, utils_1.cn)(arrow, direction === 'right'
                ? arrowRight
                : direction === 'left'
                    ? arrowLeft
                    : undefined) })));
});
